import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=8a8a7dbe&scoped=true&"
import script from "./ProductPage.vue?vue&type=script&lang=js&"
export * from "./ProductPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=8a8a7dbe&prod&lang=scss&scoped=true&"
import style1 from "./ProductPage.vue?vue&type=style&index=1&id=8a8a7dbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8a7dbe",
  null
  
)

export default component.exports